/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../pages/__root'
import { Route as MarketRouteImport } from './../pages/market'
import { Route as LoginRouteImport } from './../pages/login'
import { Route as ContactRouteImport } from './../pages/contact'
import { Route as AgentsRouteImport } from './../pages/agents'
import { Route as AccountRouteImport } from './../pages/account'
import { Route as IndexRouteImport } from './../pages/index'
import { Route as AgentsIndexRouteImport } from './../pages/agents/index'
import { Route as AuthCallbackSuccessRouteImport } from './../pages/auth/callback-success'
import { Route as AgentsAgentIdRouteImport } from './../pages/agents/$agentId'
import { Route as AgentsAgentIdIndexRouteImport } from './../pages/agents/$agentId/index'
import { Route as AgentsAgentIdOperatorExecutionIdRouteImport } from './../pages/agents/$agentId/operator/$executionId'

const MarketRoute = MarketRouteImport.update({
  id: '/market',
  path: '/market',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./../pages/market.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./../pages/login.lazy').then((d) => d.Route))
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./../pages/contact.lazy').then((d) => d.Route))
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./../pages/account.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./../pages/index.lazy').then((d) => d.Route))
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsRoute,
} as any).lazy(() =>
  import('./../pages/agents/index.lazy').then((d) => d.Route),
)
const AuthCallbackSuccessRoute = AuthCallbackSuccessRouteImport.update({
  id: '/auth/callback-success',
  path: '/auth/callback-success',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./../pages/auth/callback-success.lazy').then((d) => d.Route),
)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/$agentId',
  path: '/$agentId',
  getParentRoute: () => AgentsRoute,
} as any).lazy(() =>
  import('./../pages/agents/$agentId.lazy').then((d) => d.Route),
)
const AgentsAgentIdIndexRoute = AgentsAgentIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsAgentIdRoute,
} as any).lazy(() =>
  import('./../pages/agents/$agentId/index.lazy').then((d) => d.Route),
)
const AgentsAgentIdOperatorExecutionIdRoute =
  AgentsAgentIdOperatorExecutionIdRouteImport.update({
    id: '/operator/$executionId',
    path: '/operator/$executionId',
    getParentRoute: () => AgentsAgentIdRoute,
  } as any).lazy(() =>
    import('./../pages/agents/$agentId/operator/$executionId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/agents': typeof AgentsRouteWithChildren
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/market': typeof MarketRoute
  '/agents/$agentId': typeof AgentsAgentIdRouteWithChildren
  '/auth/callback-success': typeof AuthCallbackSuccessRoute
  '/agents/': typeof AgentsIndexRoute
  '/agents/$agentId/': typeof AgentsAgentIdIndexRoute
  '/agents/$agentId/operator/$executionId': typeof AgentsAgentIdOperatorExecutionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/market': typeof MarketRoute
  '/auth/callback-success': typeof AuthCallbackSuccessRoute
  '/agents': typeof AgentsIndexRoute
  '/agents/$agentId': typeof AgentsAgentIdIndexRoute
  '/agents/$agentId/operator/$executionId': typeof AgentsAgentIdOperatorExecutionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/agents': typeof AgentsRouteWithChildren
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/market': typeof MarketRoute
  '/agents/$agentId': typeof AgentsAgentIdRouteWithChildren
  '/auth/callback-success': typeof AuthCallbackSuccessRoute
  '/agents/': typeof AgentsIndexRoute
  '/agents/$agentId/': typeof AgentsAgentIdIndexRoute
  '/agents/$agentId/operator/$executionId': typeof AgentsAgentIdOperatorExecutionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/agents'
    | '/contact'
    | '/login'
    | '/market'
    | '/agents/$agentId'
    | '/auth/callback-success'
    | '/agents/'
    | '/agents/$agentId/'
    | '/agents/$agentId/operator/$executionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/contact'
    | '/login'
    | '/market'
    | '/auth/callback-success'
    | '/agents'
    | '/agents/$agentId'
    | '/agents/$agentId/operator/$executionId'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/agents'
    | '/contact'
    | '/login'
    | '/market'
    | '/agents/$agentId'
    | '/auth/callback-success'
    | '/agents/'
    | '/agents/$agentId/'
    | '/agents/$agentId/operator/$executionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  AgentsRoute: typeof AgentsRouteWithChildren
  ContactRoute: typeof ContactRoute
  LoginRoute: typeof LoginRoute
  MarketRoute: typeof MarketRoute
  AuthCallbackSuccessRoute: typeof AuthCallbackSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/market': {
      id: '/market'
      path: '/market'
      fullPath: '/market'
      preLoaderRoute: typeof MarketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/auth/callback-success': {
      id: '/auth/callback-success'
      path: '/auth/callback-success'
      fullPath: '/auth/callback-success'
      preLoaderRoute: typeof AuthCallbackSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/agents/$agentId/': {
      id: '/agents/$agentId/'
      path: '/'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AgentsAgentIdIndexRouteImport
      parentRoute: typeof AgentsAgentIdRoute
    }
    '/agents/$agentId/operator/$executionId': {
      id: '/agents/$agentId/operator/$executionId'
      path: '/operator/$executionId'
      fullPath: '/agents/$agentId/operator/$executionId'
      preLoaderRoute: typeof AgentsAgentIdOperatorExecutionIdRouteImport
      parentRoute: typeof AgentsAgentIdRoute
    }
  }
}

interface AgentsAgentIdRouteChildren {
  AgentsAgentIdIndexRoute: typeof AgentsAgentIdIndexRoute
  AgentsAgentIdOperatorExecutionIdRoute: typeof AgentsAgentIdOperatorExecutionIdRoute
}

const AgentsAgentIdRouteChildren: AgentsAgentIdRouteChildren = {
  AgentsAgentIdIndexRoute: AgentsAgentIdIndexRoute,
  AgentsAgentIdOperatorExecutionIdRoute: AgentsAgentIdOperatorExecutionIdRoute,
}

const AgentsAgentIdRouteWithChildren = AgentsAgentIdRoute._addFileChildren(
  AgentsAgentIdRouteChildren,
)

interface AgentsRouteChildren {
  AgentsAgentIdRoute: typeof AgentsAgentIdRouteWithChildren
  AgentsIndexRoute: typeof AgentsIndexRoute
}

const AgentsRouteChildren: AgentsRouteChildren = {
  AgentsAgentIdRoute: AgentsAgentIdRouteWithChildren,
  AgentsIndexRoute: AgentsIndexRoute,
}

const AgentsRouteWithChildren =
  AgentsRoute._addFileChildren(AgentsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  AgentsRoute: AgentsRouteWithChildren,
  ContactRoute: ContactRoute,
  LoginRoute: LoginRoute,
  MarketRoute: MarketRoute,
  AuthCallbackSuccessRoute: AuthCallbackSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
